// extracted by mini-css-extract-plugin
export default {"cards":"StatsSection_cards__505QO","card":"StatsSection_card__RhZRr","chartWrap":"StatsSection_chartWrap__vGST2"};